import React, { useEffect, useState } from 'react';
import { cmsApi } from '../../lib/api/cms';

const AdminDashboard: React.FC = () => {
  const [stats, setStats] = useState({
    sections: 0,
    services: 0,
    teamMembers: 0,
    settings: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadStats = async () => {
      try {
        const [sectionsRes, servicesRes, teamRes, settingsRes] = await Promise.all([
          cmsApi.getSections(),
          cmsApi.getServices(),
          cmsApi.getTeamMembers(),
          cmsApi.getSettings(),
        ]);

        setStats({
          sections: sectionsRes.data?.length || 0,
          services: servicesRes.data?.length || 0,
          teamMembers: teamRes.data?.length || 0,
          settings: settingsRes.data?.length || 0,
        });
      } catch (error) {
        console.error('Error loading stats:', error);
      } finally {
        setLoading(false);
      }
    };

    loadStats();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-700"></div>
      </div>
    );
  }

  const statCards = [
    { name: 'Sektsioonid', value: stats.sections, icon: '📄', color: 'bg-blue-500' },
    { name: 'Teenused', value: stats.services, icon: '🛠️', color: 'bg-green-500' },
    { name: 'Meeskonnaliikmed', value: stats.teamMembers, icon: '👥', color: 'bg-purple-500' },
    { name: 'Seaded', value: stats.settings, icon: '⚙️', color: 'bg-orange-500' },
  ];

  return (
    <div>
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900">CMS Ülevaade</h1>
        <p className="mt-2 text-gray-600">
          Tere tulemast Forestry CMS-i. Siin saad hallata veebilehe sisu.
        </p>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {statCards.map((stat) => (
          <div key={stat.name} className="bg-white overflow-hidden shadow rounded-lg">
            <div className="p-5">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <div className={`w-8 h-8 ${stat.color} rounded-md flex items-center justify-center`}>
                    <span className="text-white text-lg">{stat.icon}</span>
                  </div>
                </div>
                <div className="ml-5 w-0 flex-1">
                  <dl>
                    <dt className="text-sm font-medium text-gray-500 truncate">
                      {stat.name}
                    </dt>
                    <dd className="text-lg font-medium text-gray-900">
                      {stat.value}
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Quick Actions */}
      <div className="bg-white shadow rounded-lg">
        <div className="px-6 py-4 border-b border-gray-200">
          <h3 className="text-lg font-medium text-gray-900">Kiired toimingud</h3>
        </div>
        <div className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <div className="border border-gray-200 rounded-lg p-4 hover:border-primary-300 transition-colors">
              <div className="flex items-center mb-2">
                <span className="text-2xl mr-3">🏠</span>
                <h4 className="font-medium text-gray-900">Avalehe sisu</h4>
              </div>
              <p className="text-sm text-gray-600 mb-3">
                Muuda avalehe pealkirja, alamtiitlit ja taustapilti.
              </p>
              <a
                href="/admin/hero"
                className="text-primary-700 hover:text-primary-800 text-sm font-medium"
              >
                Halda →
              </a>
            </div>

            <div className="border border-gray-200 rounded-lg p-4 hover:border-primary-300 transition-colors">
              <div className="flex items-center mb-2">
                <span className="text-2xl mr-3">🛠️</span>
                <h4 className="font-medium text-gray-900">Teenused</h4>
              </div>
              <p className="text-sm text-gray-600 mb-3">
                Lisa, muuda või kustuta ettevõtte teenuseid.
              </p>
              <a
                href="/admin/services"
                className="text-primary-700 hover:text-primary-800 text-sm font-medium"
              >
                Halda →
              </a>
            </div>

            <div className="border border-gray-200 rounded-lg p-4 hover:border-primary-300 transition-colors">
              <div className="flex items-center mb-2">
                <span className="text-2xl mr-3">👥</span>
                <h4 className="font-medium text-gray-900">Meeskond</h4>
              </div>
              <p className="text-sm text-gray-600 mb-3">
                Halda meeskonnaliikmete andmeid ja kontaktinfot.
              </p>
              <a
                href="/admin/about"
                className="text-primary-700 hover:text-primary-800 text-sm font-medium"
              >
                Halda →
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;